jQuery(document).ready(function($) {

    /* Fancy Box
    ------------------------------*/
    $('.gallery').each(function() {
        $(this).find('.gallery-item').each(function() {
          $(this).find(".gallery-icon a").attr('data-fancybox', 'images');
          var caption = $(this).find(".gallery-caption").html();
          $(this).find(".gallery-icon a").attr('data-caption', caption);
        });
    });
    $('.woocommerce-product-gallery__wrapper').each(function() {
        $(this).find('.woocommerce-product-gallery__image').each(function() {
          $(this).find("a").attr('data-fancybox', 'images');
        });
    });
      new WOW().init();

/*    $().fancybox({
      selector : '[data-fancybox="images"]',
      loop     : true
    });
*/
      /* Back to Top
      ------------------------------*/
      $(window).scroll(function() {
          if ($(this).scrollTop() >= 50) {    // If page is scrolled more than 50px
              $('#backToTop').fadeIn();    // Fade in the arrow
          } else {
              $('#backToTop').fadeOut();   // Else fade out the arrow
          }
      });
      $('#backToTop').click(function() {      // When arrow is clicked
          $('body,html').animate({
              scrollTop : 0                  // Scroll to top of body
          }, 500);
      });
});

jQuery(document).ready(function($) {
/*    $('#hero-slider').on('init', function(e, slick) {
        var $firstAnimatingElements = $('div.hero-slide:first-child').find('[data-animation]');
        doAnimations($firstAnimatingElements);
    });
    $('#hero-slider').on('beforeChange', function(e, slick, currentSlide, nextSlide) {
              var $animatingElements = $('div.hero-slide[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
              doAnimations($animatingElements);
    });*/
    $('#hero-slider').slick({
       autoplay: true,
       autoplaySpeed: 4000,
       dots: true,
       fade: true
    });
   /* function doAnimations(elements) {
        var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elements.each(function() {
            var $this = $(this);
            var $animationDelay = $this.data('delay');
            var $animationType = 'animated ' + $this.data('animation');
            $this.css({
                'animation-delay': $animationDelay,
                '-webkit-animation-delay': $animationDelay
            });
            $this.addClass($animationType).one(animationEndEvents, function() {
                $this.removeClass($animationType);
            });
        });
    }*/
});